
import { ApiURLs } from "../../../constant/ApiUrls";
import { fetchData, } from "../../../services/api";







export const soldAdsLisitingRequest = (page = 1, pageSize = 50) => {

  return async (dispatch) => {

    const url = `${ApiURLs.SOLD_ADS}?limit=${pageSize}&offset=${page}&sort_by=${'updated_at'}`;

    // wait untill the data not received so getData function take data and url part
    dispatch({ "type": "GET_SOLD_ADS_REQUEST" });
    try {
      var soldAdsData = await fetchData(url);
      console.log(`response when we try to get sold ads   ${JSON.stringify(soldAdsData)}`)
      if (soldAdsData.status === 1) {
        dispatch({
          "type": "GET_SOLD_ADS_REQUEST_SUCCESS", "payload": soldAdsData.data.result || [],
          total: soldAdsData.data.total || 0,
        });

      } else {
        dispatch({ "type": "GET_SOLD_ADS_REQUEST_FAILED" });
      }
    } catch (error) {
      dispatch({ "type": "GET_SOLD_ADS_REQUEST_FAILED" });
      console.log(`error while try to get sold ads  ${error}`)
    }
  }
};



